

// window.$ = window.jQuery = require('jquery')
// window.$ = window.jQuery = require('jquery-validation')
require('jquery-validate')
require('./assets/jquery/js/jquery.validate.unobtrusive.js')
require('./assets/jquery/js/jquery.form.js')
require('./assets/jquery/js/jquery.unobtrusive-ajax.js')
require('./assets/jquery/js/jquery.blockUI.js')
require('./assets/jquery/js/jquery.inputmask/jquery.inputmask.bundle.js')
require('./assets/jquery/js/jquery.ui/jquery-ui.js')
require('./assets/jquery/js/jquery.mousewheel.min.js')
require('./assets/jquery/js/jquery.numeric.js')
require('./assets/tmpl/js/tmpl.min.js')
//require('./assets/jquery/js/jquery-ui.js')
//require('./assets/jquery/js/jquery.ui/jquery.ui.js')
//require('./assets/jquery/js/jquery.ui/jquery.ui.widget.js')
//require('./assets/jquery/js/jquery.fileupload/jquery.fileupload-image.js')
require('./assets/jquery/js/jquery.fileupload/jquery.fileupload.js')
require('./assets/jquery/js/jquery.fileupload/jquery.fileupload-process.js')
require('./assets/jquery/js/jquery.fileupload/jquery.fileupload-ui.js')
//require('./assets/jquery/js/jquery.fileupload/jquery.fileupload-jquery-ui.js')
//require('./assets/jquery/js/jquery.fileupload/jquery.fileupload-validate.js')
require('./assets/jquery/js/jquery.fileupload/jquery.iframe-transport.js')

require('./Content/scss/elementos-fixos.scss')
require('./Content/scss/tabela-produtos.scss')  

require('./assets/bootstrap/css/bootstrap/bootstrap.less')
require('./assets/toastr/css/toastr.css'),
require('./assets/font-awesome/css/all.css'),
require('./assets/colpick/css/colpick.css'),
require('./assets/jquery-ui/css/jquery-ui.css'),
require('./assets/jquery-ui/css/jquery-ui.structure.css'),
require('./assets/jquery-ui/css/jquery-ui.theme.css'),
require('./assets/jquery.fileupload/css/jquery.fileupload.css'),
require('./assets/lightGallery/css/lightgallery.css'),
require('./assets/lightslider/css/lightslider.css'),
require('./assets/summernote/css/summernote.css'),
require('./assets/sonatra-jquery-sidebar/css/scroller.css'),
require('./assets/sonatra-jquery-sidebar/css/sidebar.css'),
require('./assets/sonatra-jquery-sidebar/css/sidebar-bootstrap.css')
require('./assets/bootstrap/css/bootstrap-fileinput.css')

require('./assets/bootstrap/js/bootstrap.js')
require('./assets/bootstrap/js/bootstrap-datetimepicker.js')
require('./Scripts/toastr.js')
require('./assets/accountingjs/js/accounting.extensions.js')


Backbone.Marionette = require('backbone.marionette')
require('./assets/mustache/js/mustache.js')
require('holderjs')
require('./assets/colpick/js/colpick.js')
require('./assets/summernote/js/summernote.js')
require('./assets/summernote/js/lang/summernote-pt-BR.js')
require('./assets/lightGallery/js/lightgallery.js')
require('./assets/lightGallery/js/lg-fullscreen.js')
require('./assets/lightGallery/js/lg-thumbnail.js')
require('./assets/lightGallery/js/lg-video.js')
require('./assets/lightGallery/js/lg-autoplay.js')
require('./assets/lightGallery/js/lg-zoom.js')
require('./assets/lightGallery/js/lg-hash.js')
require('./assets/lightGallery/js/lg-pager.js')
require('./assets/imageGallery/js/imageGallery.js')
require('./assets/select2/js/select2.js')
require('./assets/select2/js/i18n/pt-BR.js')
require('./assets/vanilla-masker/js/vanilla-masker.js')
window.ko = require('knockout')
window.ko.mapping = require('knockout-mapping') 
require('./assets/jquery/js/jquery.aop.js')
require('./assets/hammerjs/js/hammer.min.js')
require('./assets/sonatra-jquery-scroller/js/scroller.js')
require('./assets/sonatra-jquery-scroller/js/sticky-header.js')
require('./assets/sonatra-jquery-sidebar/js/sidebar.js')
require('./assets/jquery.slimscroll/js/jquery.slimscroll.min.js')
require('./assets/accountingjs/js/accounting.extensions.js')
require('./assets/jquery/js/jquery.extensions.js')
require('./assets/select2/js/select2.extensions.js')
require('./assets/knockout/js/knockout.extensions.js')
require('./assets/knockout/js/knockout.datepicker.js')
require('./assets/knockout/js/knockout.form.js')
require('./assets/knockout/js/knockout.select2.js')
require('./assets/knockout/js/knockout.summernote.js')
require('./assets/knockout/js/knockout.fileupload.js')


window.$ = window.jQuery = require('jquery')